@if (entry?.base?.display) {
  <div>
    @if (!memberLoggedIn) {
      <app-login-page
        [forgotPasswordUrl]="entry?.custom?.forgotPasswordUrl"
        [hideRegister]="true"
        [hideForgotPwd]="true"
      [loginStrategy]="loginStrategy"></app-login-page>
    }
    @if (memberLoggedIn && memberEligible) {
      <div>
        <div class='member-message'>
          <p>
            <span class='material-symbols-outlined success-green'>check_circle</span>
          {{ entry?.custom?.memberEligibleMessage ? entry.custom.memberEligibleMessage : 'You are eligible for WHB' }}</p>
        </div>
      </div>
    }
  </div>
}